import { Modal, Text, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Button, Select, useToast, Center, Heading, VStack } from "@chakra-ui/react";
import OlaggFormSelect from "../../../../components/Forms/OlaggFormSelect";
import { AdminCouponsEndpoints, AdminUserEndpoints, fetcher } from "@olagg/api-hooks";
import OlaggFormInput from "../../../../components/Forms/OlaggFormInput";
import { useEffect, useState } from "react";
import useBlockchainNetwork from "../../../BlockchainTokenCatalog/hooks/useBlockchainNetwork";
import useBlockchainTokenCatalog from "../../../BlockchainTokenCatalog/hooks/useBlockchainTokenCatalog";
import OlaggForm from "../../../../components/Forms/OlaggForm";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"
import { useParams } from "react-router-dom";
import { ROUTES } from "../../../../consts/routes";


const schema = yup.object().shape({
    limit: yup.number().min(0).required(),
    percentage: yup.number().min(0).max(100).required(),
    userId: yup.string().required(),
    blockchainTokenId: yup.string().nullable().optional(),
    dueDate: yup.date().nullable().optional()
})

const PercentageCoupon = () => {
    const { id } = useParams()
    const [coupon, setCoupon] = useState<any>(undefined);
    const [selectedNetwork, setSelectedNetwork] = useState<string | undefined>(undefined);
    const [filteredBlockchainTokens, setFilteredBlockchainTokens] = useState<any[]>([]);
    const { all: allNetworks, blockchainNetworks } = useBlockchainNetwork();
    const { all, blockchainTokens } = useBlockchainTokenCatalog();
    const toast = useToast();

    const userOptions = async (name?: string) =>
        fetcher(AdminUserEndpoints.all({ page: 1, limit: 5, query: name }))
            .then(response => response.users.map((user: any) => ({
                label: `ID: ${user.id} - ${user.name} - ${user.email}`,
                value: user.id
            })))
            .catch(error => {
                console.error('Error fetching users:', error);
                return [];
            });

    const useFormMethods = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: coupon
    })

    const handleGenerateCodes = (data: any) =>
        fetcher(AdminCouponsEndpoints.create(data))
            .then(() => {
                toast({
                    title: `Cupon generado`,
                    status: 'success',
                    position: 'bottom-right',
                    duration: 2000,
                    isClosable: false
                });
                window.location.href = `${ROUTES.MARKETPLACE.all}#cupones`;
            }).catch((error) => {
                toast({
                    title: `Error generando cupon`,
                    status: 'error',
                    position: 'bottom-right',
                    description: error.message,
                    duration: 2000,
                    isClosable: false
                });
            });

    const handleSelectedNetwork = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const networkName = event.target.value;
        setSelectedNetwork(networkName);
    }

    useEffect(() => {
        all({ page: 1, limit: 100 });
        allNetworks({ page: 1, limit: 100 }).then(() => {
            setFilteredBlockchainTokens(blockchainTokens);
            console.log(filteredBlockchainTokens)
        })
    }, []);

    useEffect(() => {
        if (id) {
            fetcher(AdminCouponsEndpoints.show(id))
                .then((response) => {
                    setCoupon(response.coupon);
                    useFormMethods.reset(response.coupon);
                    setSelectedNetwork(response.coupon.blockchainTokenNetworkId);
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }, [id])

    if (id && !coupon)
        return <>Cargando...</>

    return (
        <Center w={'full'} pb={4}>
            <VStack color={'white'}>
                <Heading my={2}>
                    Cupon de porcentaje
                </Heading>
                <OlaggForm
                    useFormMethods={useFormMethods}
                    onSubmit={handleGenerateCodes}
                >

                    <Text mb={4}>¿A qué usuario deseas asignar el cupon?</Text>
                    <OlaggFormSelect
                        label="Usuario"
                        controlName={'userId'}
                        required={true}
                        newVersion
                        staticOptions={coupon?.user ? [{ label: `ID: ${coupon.user.id} - ${coupon.user.name} - ${coupon.user.email}`, value: coupon.user.id }] : []}
                        asyncOptions={userOptions}
                        isSearchable
                        placeholder="Selecciona un usuario"
                    />

                    <OlaggFormInput
                        label="Ingresa el porcentaje de descuento del cupon (%)"
                        controlName='percentage'
                        required={true}
                    />

                    <OlaggFormInput
                        label="Monto maximo que se puede descontar del precio"
                        controlName='limit'
                        required={true}
                    />

                    <OlaggFormInput
                        label='Fecha de vencimiento del cupon'
                        controlName='dueDate'
                        inputType='date'
                        description={`Zona horaria: UTC`}
                        datePickerProps={{ backgroundColor: 'white' }}
                        required={false}
                    />

                    {/*<Text fontSize={'18px'} fontWeight='700'>Blockchain Token Network Filter</Text>
                    <Select value={selectedNetwork} style={{ marginBottom: '10px' }} placeholder="Select network" onChange={handleSelectedNetwork}>
                        {
                            blockchainNetworks?.map(network => (
                                <option style={{ backgroundColor: 'black' }} key={network.id} value={network.id}>{network.name}</option>
                            ))
                        }
                    </Select>
                    {selectedNetwork && (
                        <>
                            <Text fontSize={'18px'} fontWeight='700'>Blockchain Token</Text>
                            <OlaggFormSelect
                                controlName={'blockchainTokenId'}
                                staticOptions={blockchainTokens?.map(t => ({
                                    value: t.id,
                                    label: t.name
                                }))}
                                required={true}
                                newVersion
                                isSearchable
                            />
                        </>
                    )}*/}


                    <Button
                        p={'0 10px'}
                        w="full"
                        variant="filledGradient"
                        fontSize="16px"
                        fontWeight="600"
                        cursor={'pointer'}
                        type='submit'
                    >
                        Generar
                    </Button>
                </OlaggForm>
            </VStack>
        </Center>
    )
}

export default PercentageCoupon;